import {
  mapActions, mapState, mapMutations, mapGetters,
} from 'vuex';
import _ from '@/lodash';
import searchLoadingComponent from './general/search-loading-state.vue';
import searchResultTotal from './general/search-result-total.vue';
import searchQuickFilters from './general/search-quick-filters.vue';
import searchFilters from './filters/search-filters-parent.vue';
import searchInput from './general/search-input.vue';
import searchResults from './general/search-results.vue';
import searchSort from './general/search-sort.vue';
import searchType from './general/search-type.vue';
import searchPagination from './general/search-pagination.vue';
import searchMobileHeader from './general/search-mobile-header.vue';
import searchAutocompleteAlg from './general/search-auto-complete-alg.vue';
import searchAlternativeLocations from './general/search-alternative-locations.vue';

export default {
  data() {
    return {
      filterOpen: false,
      pauseWatcherForQuery: false,
    };
  },
  components: {
    'search-result-total': searchResultTotal,
    'search-type': searchType,
    'search-input': searchInput,
    'search-sort': searchSort,
    'search-results': searchResults,
    'search-pagination': searchPagination,
    'search-filters': searchFilters,
    'search-quick-filters': searchQuickFilters,
    'search-loading-state': searchLoadingComponent,
    'search-mobile-header': searchMobileHeader,
    'search-autocomplete-alg': searchAutocompleteAlg,
    'search-alternative-locations': searchAlternativeLocations,
  },

  computed: {
    ...mapState('search', {
      resultCount: (state) => state.resultCount,
      searchType: (state) => state.query.show,
      query: (state) => state.query,
      isFirstLoading: (state) => state.isFirstLoading,
      url: (state) => state.config.baseUrl,
      isSearchResultsLoading: (state) => state.uiLoadingState,
    }),
    ...mapGetters('search', {
      getQueryParamsRefined: 'getQueryParamsRefined',
      isQueryWatcherPaused: 'isQueryWatcherPaused',
    }),
  },

  watch: {
    query: {
      deep: true,
      handler() {
        if (!this.isFirstLoading) {
          if (!window.history.pushState) {
            const query = this.getQueryParamsRefined;
            const ieUrl = Object.keys(query).reduce((accumulator, param) => {
              accumulator += `&${param}=${query[param]}`;
              return accumulator;
            }, `${this.url}?`).replace('?&', '?');

            console.log(ieUrl);

            window.location.href = ieUrl;
            return false;
          }
          if (!this.isQueryWatcherPaused) {
            this.setLoadingState({ loadingState: true });
            this.submitSearch();
          }
        }
        return false;
      },
    },
  },

  methods: {
    ...mapActions('search', {
      getAjaxResults: 'getAjaxResults',
    }),
    ...mapMutations('search', {
      setLoadingState: 'setLoadingState',
    }),

    submitSearch: _.debounce(function() { // eslint-disable-line
      this.getAjaxResults().catch((error) => {
        if (error.message === 'cancelled-request') {
          console.log('request cancelled.');
        } else {
          console.log(error);
          this.$bus.$emit('flashNoticeError', {
            action: 'search request failed',
          });
          this.setLoadingState({ loadingState: false });
        }
      });
    }, 700),

    toggleFilters() {
      this.filterOpen = !this.filterOpen;
    },
  },
};
